export default __webpack_public_path__ + "static/media/documents2.53cb5c58.svg";